import { CfgApiMenu, CfgApiMenuItem } from '../../types/CfgApiMenu.type'
import { MenuItem } from '../../types/MenuItem.type'
import { makeUrlRelative } from './makeUrlRelative'

export const extractMenuItems = (
  cfgApiMenu: CfgApiMenu,
  depth: number = Infinity
): MenuItem[] => {
  const simplifyMenu = (
    menuItems: CfgApiMenuItem[],
    currentDepth: number
  ): MenuItem[] => {
    if (currentDepth > depth) {
      return []
    }
    return menuItems.map(item => {
      const { name, url, menuItems } = item.HstMenuItemRepresentation
      return {
        name,
        url: makeUrlRelative(url),
        menuItems: simplifyMenu(menuItems, currentDepth + 1)
      }
    })
  }

  return simplifyMenu(cfgApiMenu.menuItems, 1)
}
